import { render, staticRenderFns } from "./TeacherReward.vue?vue&type=template&id=f7c23734&scoped=true&"
import script from "./TeacherReward.vue?vue&type=script&lang=js&"
export * from "./TeacherReward.vue?vue&type=script&lang=js&"
import style0 from "./TeacherReward.vue?vue&type=style&index=0&id=f7c23734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c23734",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
